export default {
  bookSteps: [],
  etcBookSteps: [],
  nowStep: 0,
  bookList: [],
  forwardLines: [],
  backwardLines: [],
  withCalendarYn: false,
  bookUid: "",
  pgList: [],
  isForwardBookCountExceeded: false,
  isBackwardBookCountExceeded: false,
  bookableDates: {},
  etcBookableDates: {},
};
